import {
    GET_INFO

} from '../actions/testActions';



export default function(state = [], action){
	switch(action.type){
		case GET_INFO:
		  return action.payload.data;

		default:
		  return state;

  } // END switch

} // END function


// WEBPACK FOOTER //
// ./src/redux/reducers/testReducer.js